import React from 'react'
import FooterExLinkCard from './FooterExLinkCard'
import './FooterRightAreaCard.css'

const FooterRightAreaCard = () => {
    return (
        <div className="FooterRightArea">
            <FooterExLinkCard
                title = "NTF Marketplace"
            />
            <FooterExLinkCard
                title = "Explore"
            />
            <FooterExLinkCard
                title = "Community"
            />
        </div>
    )
}

export default FooterRightAreaCard
